__turbopack_context__.v({
  "bg": "r4A5dG_bg",
  "bottomScrim": "r4A5dG_bottomScrim",
  "copy": "r4A5dG_copy",
  "cta": "r4A5dG_cta",
  "eyebrow": "r4A5dG_eyebrow",
  "overlay": "r4A5dG_overlay",
  "section": "r4A5dG_section",
  "stacked": "r4A5dG_stacked",
  "subtitle": "r4A5dG_subtitle",
  "title": "r4A5dG_title",
  "titleGroup": "r4A5dG_titleGroup",
});
